import { api } from '@converse/headless';
import { ObservableElement } from 'shared/components/observable.js';
import tplPlaceholder from './templates/placeholder.js';

class Placeholder extends ObservableElement {
    static get properties() {
        return {
            ...super.properties,
            model: { type: Object },
        };
    }

    constructor() {
        super();
        this.model = null;
        this.observable = /** @type {import('shared/components/types').ObservableProperty} */ ('once');
        this.intersectionRatio = 0.1;
    }

    render() {
        return tplPlaceholder(this);
    }

    /**
     * @param {Event} [ev]
     */
    fetchMissingMessages(ev) {
        ev?.preventDefault?.();
        this.model.fetchMissingMessages();
    }

    /**
     * @param {IntersectionObserverEntry} _entry
     */
    onVisibilityChanged(_entry) {
        if (this.isVisible && !this.model.get('fetching')) {
            this.fetchMissingMessages();
        }
    }
}

api.elements.define('converse-history-placeholder', Placeholder);

export default Placeholder;
